import { Injectable } from '@angular/core';
import { AddOrganisationRequest, GetOrganisationForUserConnectedRequest } from '@aoe/client';
import { Observable } from 'rxjs';
import { OrganisationAdminResponse } from '../interfaces/OrganisationAdminResponse.interface';
import { CreateOrganisationResponse, OrganisationResponse } from '../interfaces/OrganisationResponse.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService extends ApiService {

  getOrganisationWithoutToken(): Observable<OrganisationResponse> {
    return this.get<OrganisationResponse>('organisation');
  }

  getOrganisationById(organisationId: string): Observable<OrganisationAdminResponse> {
    return this.get<OrganisationResponse>(`organisation/${organisationId}`);
  }

  getOrganisations(payload: GetOrganisationForUserConnectedRequest) {
    return this.get<OrganisationResponse>(`organisation`, payload);
  }

  createOrganisation(payload: AddOrganisationRequest) {
    return this.post<CreateOrganisationResponse, AddOrganisationRequest>(`organisation`, payload);
  }
}
